export class crsDetailsModel{

    public CountryOfTaxResidenceUDF:string;
    public TINUDF:string;
    public TINReasonUDF:string;
    public OutsidePakCheck:string;
    constructor(){
        
    }
}